/**
 * Remplace la liste native du menu de coloris du bundle par un panneau maison.
 *
 * Le menu reste un vrai `<select>` : c'est lui qui porte la valeur, et c'est sur
 * son evenement `change` que reposent le script du theme (prix, vignette) et la
 * synchronisation du carrousel. On se contente de neutraliser son ouverture et
 * d'ecrire dedans depuis le panneau. Rien d'autre dans la page n'a besoin de
 * savoir que l'affichage a change.
 *
 * Le panneau est pose sur le `body` en position fixe, et non dans la rangee :
 * la carte du bundle porte un `overflow: hidden`, qui rognait tout ce qui
 * depassait de son cadre. Ancre au corps du document, plus aucun conteneur ne
 * peut le couper.
 */
(function () {
  var MARGIN = 8;
  var paires = [];
  var openRow = null;
  var openPanel = null;

  function swatchMap(row) {
    var host = row.closest('[data-qb-swatches]');
    if (!host) return {};
    try {
      return JSON.parse(host.getAttribute('data-qb-swatches') || '{}');
    } catch (e) {
      return {};
    }
  }

  /** texture du coloris si elle est definie, sinon la photo de la variante */
  function visualFor(option, map) {
    var label = (option.textContent || '').trim().toLowerCase();
    return map[label] || option.getAttribute('data-variant-image') || '';
  }

  function buildPanel(row, select) {
    var map = swatchMap(row);
    var panel = document.createElement('div');
    panel.className = 'kalm-vpick__panel';
    panel.setAttribute('role', 'listbox');

    Array.prototype.forEach.call(select.options, function (option) {
      if (option.disabled) return;

      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'kalm-vpick__option';
      item.setAttribute('role', 'option');
      item.dataset.value = option.value;

      var visual = visualFor(option, map);
      var dot = document.createElement('span');
      dot.className = 'kalm-vpick__dot';
      if (visual) {
        var img = document.createElement('img');
        img.src = visual;
        img.alt = '';
        img.loading = 'lazy';
        dot.appendChild(img);
      }

      var text = document.createElement('span');
      text.className = 'kalm-vpick__label';
      text.textContent = (option.textContent || '').trim();

      item.appendChild(dot);
      item.appendChild(text);

      item.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (select.value !== option.value) {
          select.value = option.value;
          // `bubbles` est indispensable : le script du theme ecoute au niveau
          // du conteneur, pas sur chaque menu.
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        close();
      });

      panel.appendChild(item);
    });

    return panel;
  }

  function markSelected(panel, select) {
    panel.querySelectorAll('.kalm-vpick__option').forEach(function (item) {
      var isSelected = item.dataset.value === select.value;
      item.classList.toggle('kalm-vpick__option--selected', isSelected);
      item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });
  }

  /**
   * Place le panneau sous la rangee, en coordonnees d'ecran. Il bascule vers la
   * gauche s'il sortait a droite (cas du 2e article du bundle sur mobile), et
   * s'ouvre vers le haut s'il n'y a pas la place en dessous.
   */
  function placePanel(row, panel) {
    var rect = row.getBoundingClientRect();

    panel.style.minWidth = rect.width + 'px';
    panel.style.left = '0px';
    panel.style.top = '0px';

    var width = panel.offsetWidth;
    var height = panel.offsetHeight;

    var left = rect.left;
    if (left + width > window.innerWidth - MARGIN) left = rect.right - width;
    if (left < MARGIN) left = MARGIN;

    var top = rect.bottom + 4;
    if (top + height > window.innerHeight - MARGIN && rect.top - height - 4 > MARGIN) {
      top = rect.top - height - 4;
    }

    panel.style.left = Math.round(left) + 'px';
    panel.style.top = Math.round(top) + 'px';
  }

  function close() {
    if (!openPanel) return;
    openPanel.classList.remove('kalm-vpick__panel--open');
    if (openRow) {
      var trigger = openRow.querySelector('.kalm-vpick__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
    openRow = null;
    openPanel = null;
  }

  function open(row, panel, select) {
    if (openPanel === panel) {
      close();
      return;
    }
    close();
    markSelected(panel, select);
    panel.classList.add('kalm-vpick__panel--open');
    var trigger = row.querySelector('.kalm-vpick__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    openRow = row;
    openPanel = panel;
    placePanel(row, panel);
  }

  /** retire les panneaux dont la rangee a quitte la page */
  function pruneOrphans() {
    paires = paires.filter(function (paire) {
      if (document.contains(paire.row)) return true;
      if (paire.panel === openPanel) close();
      paire.panel.remove();
      return false;
    });
  }

  function enhance(row) {
    // On teste la presence reelle du declencheur plutot qu'un drapeau : si le
    // theme venait a reconstruire la rangee, elle serait re-equipee au lieu de
    // rester avec un menu neutralise et plus rien pour l'ouvrir.
    if (row.querySelector('.kalm-vpick__trigger')) return;

    var select = row.querySelector('[data-ref="quantity-break-variant-picker"]');
    if (!select || select.options.length < 2) return;

    row.classList.add('kalm-vpick');
    // neutralise en JS, et non en CSS : un menu reconstruit redevient
    // utilisable tel quel tant qu'il n'a pas ete re-equipe
    select.style.pointerEvents = 'none';

    var panel = buildPanel(row, select);
    document.body.appendChild(panel);
    paires.push({ row: row, panel: panel });

    // bouton transparent pose sur toute la rangee : l'apparence fermee reste
    // celle du theme, seul le clic est detourne
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'kalm-vpick__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-label', select.getAttribute('aria-label') || 'Choisir un coloris');
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      open(row, panel, select);
    });

    row.appendChild(trigger);

    // le coloris peut aussi changer depuis le script du theme
    select.addEventListener('change', function () {
      markSelected(panel, select);
    });
  }

  function init() {
    pruneOrphans();
    document.querySelectorAll('.quantity-break__variant-picker-row').forEach(enhance);
  }

  document.addEventListener('click', function (event) {
    if (!openPanel) return;
    if (openPanel.contains(event.target)) return;
    if (openRow && openRow.contains(event.target)) return;
    close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  // En position fixe, le panneau ne suit pas la page tout seul : on le recale
  // au defilement plutot que de le refermer sous le doigt. Il ne se ferme que
  // si son menu sort de l'ecran.
  function reposition() {
    if (!openRow || !openPanel) return;

    var rect = openRow.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) {
      close();
      return;
    }

    placePanel(openRow, openPanel);
  }

  window.addEventListener('scroll', reposition, true);
  window.addEventListener('resize', reposition);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // le bundle reconstruit ses rangees quand on bascule d'offre
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', function () {
    setTimeout(init, 0);
  });
})();
